import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowLeftIcon, ArrowRightIcon } from '@yonderland/andes-icons';
import { Box, Breakpoint, ButtonLink, ConditionalWrapper, Link } from '@yonderland/andes-react';
const Button = ({ label, link, icon, target, style, theme, paddings, variant, inverse, fullWidth, hideOnMobile = false, analyticsId, }) => {
    const buttonProps = Object.assign({ variant,
        theme,
        inverse,
        fullWidth, href: link, target }, (icon === 'left'
        ? { iconLeft: { source: ArrowLeftIcon } }
        : icon === 'right'
            ? { iconRight: { source: ArrowRightIcon } }
            : {}));
    return (_jsx(Box, Object.assign({}, paddings, { children: _jsx(ConditionalWrapper, { condition: hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsx(ConditionalWrapper, { condition: !!analyticsId, wrapper: children => _jsx("div", { "data-analytics-bannerid": analyticsId, children: children }), children: style === 'base' ? _jsx(ButtonLink, Object.assign({}, buttonProps, { children: label })) : _jsx(Link, Object.assign({}, buttonProps, { children: label })) }) }) })));
};
export default Button;
